import { Input } from "@/app/admin/_common/ui/input";
import { Label } from "@/app/admin/_common/ui/label";
import { Switch } from "@/app/admin/_common/ui/switch";
import { Controller } from "react-hook-form";

interface PromoInputProps {
  control: any;
  errors: any;
}

export const CodeInput = ({ control, errors }: PromoInputProps) => (
  <div className="grid gap-3">
    <Label htmlFor="code">Promo Code</Label>
    <Controller
      name="code"
      control={control}
      render={({ field }) => (
        <Input
          id="code"
          {...field}
          value={field.value ?? ""}
          onChange={(e) => field.onChange(e.target.value.toUpperCase())}
          placeholder="SUMMER20"
          className="font-mono"
          autoComplete="off"
        />
      )}
    />
    {errors.code && <span className="text-[12px] text-red-600">{errors.code?.message}</span>}
  </div>
);

export const DiscountInput = ({ control, errors }: PromoInputProps) => (
  <div className="grid gap-3">
    <Label htmlFor="discount_percent">Discount</Label>
    <Controller
      name="discount_percent"
      control={control}
      render={({ field }) => (
        <div className="relative">
          <Input
            id="discount_percent"
            type="number"
            min={1}
            max={100}
            {...field}
            value={field.value ?? ""}
            onChange={(e) => field.onChange(e.target.value === "" ? "" : Number(e.target.value))}
            placeholder="20"
            className="pr-7"
          />
          <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-[12.5px] text-muted-foreground">
            %
          </span>
        </div>
      )}
    />
    {errors.discount_percent ? (
      <span className="text-[12px] text-red-600">{errors.discount_percent?.message}</span>
    ) : (
      <span className="text-[12px] text-muted-foreground">Enter a value between 1 and 100.</span>
    )}
  </div>
);

export const ActiveInput = ({ control }: PromoInputProps) => (
  <div className="flex items-center gap-2">
    <Controller
      name="active"
      control={control}
      render={({ field }) => (
        <Switch id="active" checked={!!field.value} onCheckedChange={field.onChange} />
      )}
    />
    <Label htmlFor="active" className="cursor-pointer text-[12.5px] text-muted-foreground">
      Active — customers can use this code
    </Label>
  </div>
);
